import { Text } from '@chakra-ui/layout'

const TextTelFormat = ({ value, ...rest }) => {
    let text = '-'
    if (value) {
        if (value.length === 10) {
            const v = value.split("")
            text = `${v[0]}${v[1]}${v[2]} ${v[3]}${v[4]}${v[5]} ${v[6]}${v[7]}${v[8]}${v[9]}`
        } else {
            text = value
        }
    }
    return (
        <Text {...rest}>{text}</Text>
    )
}

export default TextTelFormat